import {
  CREATE_ORDER,
  FETCH_ADDRESS_SEARCH,
  FETCH_ADDRESS_TRANSLATE,
  FETCH_SERVICE_TYPE,
  FETCH_PAYMENT,
  FETCH_QUOTE,
  PAX_FETCH_ADDRESS_TRANSLATE,
  PAX_FETCH_SERVICE_TYPE,
  PAX_FETCH_PAYMENT_METHODS,
  PAX_FETCH_SEARCH_ADDRESS,
} from './endpoint-constants';
import { isEmpty } from '../common/utils/data-utils';

const getCreateOrderV2Ept = () => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}${CREATE_ORDER}`;
};

const getQuotesEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${FETCH_QUOTE}`;
};

const getV2QuoteEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}/quote`;
};

export const getV2QuotesEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}/quotes`;
};

const getAddressTranslationEpt = ({ lat, lng, companyID }) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${FETCH_ADDRESS_TRANSLATE}?latitude=${lat}&longitude=${lng}&companyID=${companyID}`;
};

const getPaxAddressTranslationEpt = ({ lat, lng }) => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}${PAX_FETCH_ADDRESS_TRANSLATE}?latitude=${lat}&longitude=${lng}`;
};

const getAddressSearchEpt = ({
  keyword,
  latlng,
  companyID,
  countryCode,
  isToggle,
}) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  const url = new URL(`${geAPI}${FETCH_ADDRESS_SEARCH}`);
  url.searchParams.append('keyword', keyword);
  url.searchParams.append('companyID', companyID);
  if (countryCode) {
    url.searchParams.append('countryCode', countryCode);
  }

  if (!isEmpty(latlng)) {
    url.searchParams.append('latitude', latlng.lat);
    url.searchParams.append('longitude', latlng.lng);
  }

  if (isToggle !== undefined) {
    url.searchParams.append('isToggle', isToggle);
  }
  return url.toString();
};

const paxFetchSearchAddressEpt = ({
  keyword,
  latlng,
  countryCode,
  isToggle,
}) => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  const url = new URL(`${geAPIV2}${PAX_FETCH_SEARCH_ADDRESS}`);
  url.searchParams.append('input.keyword', keyword);

  if (countryCode) {
    url.searchParams.append('input.countryCode', countryCode);
  }

  if (
    !isEmpty(latlng) &&
    latlng.lat !== null &&
    latlng.lat !== undefined &&
    latlng.lng !== null &&
    latlng.lng !== undefined
  ) {
    url.searchParams.append('input.latitude', latlng.lat);
    url.searchParams.append('input.longitude', latlng.lng);
  }

  if (isToggle !== undefined) {
    url.searchParams.append('isToggle', isToggle);
  }
  return url.toString();
};

const getPaymentDetailsEpt = (companyID, countryCode, groupID) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${FETCH_PAYMENT}?companyID=${companyID}&countryCode=${countryCode}&groupID=${groupID}`;
};

const fetchServiceTypesEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;

  return `${geAPI}${FETCH_SERVICE_TYPE}`;
};

const paxFetchServiceTypesEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;

  return `${geAPIV2}${PAX_FETCH_SERVICE_TYPE}`;
};

const paxFetchPaymentMethodsEpt = countryCode => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;

  return `${geAPIV2}${PAX_FETCH_PAYMENT_METHODS}?input.countryCode=${countryCode}`;
};

const rebookEndpoint = code => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  const geAPIV3 = geAPI.replace('/v1', '/v3');
  return `${geAPIV3}/rebook?code=${code}`;
};

export const fetchOffersEndpoint = () => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  return `${geWebAPIBase}/v3/offers/eligible-offers`;
};

export const fetchOffersByPromoCodeEndpoint = ({
  latitude,
  longitude,
  promoCode,
}) => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  const urlSearchParams = new URLSearchParams({
    latitude,
    longitude,
    promoCode,
  });
  return `${geWebAPIBase}/v3/offers/promos-by-code?${urlSearchParams.toString()}`;
};

export const getV3OfferEndpoint = () => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  return `${geWebAPIBase}/v3/offers/get-offer`;
};

export default {
  getCreateOrderV2Ept,
  getQuotesEpt,
  getV2QuoteEpt,
  getV2QuotesEpt,
  getAddressTranslationEpt,
  getAddressSearchEpt,
  getPaymentDetailsEpt,
  fetchServiceTypesEpt,
  paxFetchSearchAddressEpt,
  paxFetchServiceTypesEpt,
  getPaxAddressTranslationEpt,
  paxFetchPaymentMethodsEpt,
  rebookEndpoint,
  fetchOffersEndpoint,
  fetchOffersByPromoCodeEndpoint,
  getV3OfferEndpoint,
};
